import React, { useState } from 'react';
import { Card } from './Card';
import cx from 'classnames';
import { Icons } from '../Icons';
export const CardCollapsibleFreeform = ({ title, description, items, loading, }) => {
    const [isCollapsed, setisCollapsed] = useState(true);
    return (React.createElement(Card, null,
        React.createElement("div", { className: "card-collapsible" },
            React.createElement("div", { className: "card-collapsible_header" },
                React.createElement("h6", { className: cx({ 'card-collapsible_title--loading': loading }) }, title),
                React.createElement("p", { className: cx('card-collapsible_description', {
                        'card-collapsible_description--loading': loading,
                    }) }, description)),
            items && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: cx('card-collapsible_content--free', { 'is-hidden': isCollapsed }) }, !isCollapsed && items),
                React.createElement("button", { className: cx('card-collapsible_cta', {
                        'card-collapsible_cta--loading': loading,
                    }), onClick: () => setisCollapsed(!isCollapsed) },
                    !loading && (isCollapsed ? `Show details` : 'Hide details'),
                    !loading && (React.createElement(Icons, { iconName: `ic-ui-caret-${isCollapsed ? 'down' : 'up'}`, size: 20 }))))))));
};
//# sourceMappingURL=CardCollapsibleFreeform.js.map